import { z } from 'zod'
import { oc } from '@orpc/contract'
import { patientInvoiceKindSchema } from './copay-status.contract'

// One endpoint for both modes: "charge over the phone" (staff opens the URL)
// and "send payment link" (patient opens it) — only who opens the URL differs.
export const createCopayCheckout = oc
  .route({ method: 'POST', path: '/v2/copay/{encounterId}/checkout' })
  .input(
    z.object({
      encounterId: z.string().min(1),
      kind: patientInvoiceKindSchema.default('copay'),
      // Stripe minimum charge is $0.50; cap guards against fat-fingered amounts.
      amountCents: z.number().int().min(50).max(500_000),
    }),
  )
  .output(
    z.object({
      checkoutUrl: z.string(),
      sessionId: z.string(),
    }),
  )
